/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListVersions } from "../funcs/skillsListVersions.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListSkillVersionsRequest,
  ListSkillVersionsResponse,
  ListSkillVersionsSecurity,
} from "../models/operations/listskillversions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SkillVersionsQueryData = ListSkillVersionsResponse;

export type SkillVersionsInfiniteQueryData = PageIterator<
  ListSkillVersionsResponse,
  { cursor: string }
>;

export type SkillVersionsPageParams = PageIterator<
  ListSkillVersionsResponse,
  { cursor: string }
>["~next"];

export function prefetchSkillVersions(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListSkillVersionsRequest,
  security?: ListSkillVersionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillVersionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSkillVersionsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListSkillVersionsRequest,
  security?: ListSkillVersionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSkillVersionsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SkillVersionsPageParams,
    getNextPageParam: (previousPage: SkillVersionsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSkillVersionsQuery(
  client$: GramCore,
  request: ListSkillVersionsRequest,
  security?: ListSkillVersionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SkillVersionsQueryData>;
} {
  return {
    queryKey: queryKeySkillVersions({
      id: request.id,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function skillVersionsQueryFn(
      ctx,
    ): Promise<SkillVersionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListVersions(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSkillVersionsInfiniteQuery(
  client$: GramCore,
  request: ListSkillVersionsRequest,
  security?: ListSkillVersionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SkillVersionsPageParams>,
  ) => Promise<SkillVersionsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySkillVersionsInfinite({
      id: request.id,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function skillVersionsQuery(
      ctx,
    ): Promise<SkillVersionsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(skillsListVersions(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(skillsListVersions(
        client$,
        {
          ...request,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySkillVersions(
  parameters: {
    id: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listVersions", parameters];
}

export function queryKeySkillVersionsInfinite(
  parameters: {
    id: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listVersions", "infinite", parameters];
}
